import { useCallback } from 'react';

import { useBoolean } from '@dreryk/react-common';

import { EzwmSenderCodeRemoveModal } from './EzwmSenderCodeRemoveModal';
import { EzwmSenderCodeRemoveModalOpener } from './EzwmSenderCodeRemoveModalOpener';

const useEzwmSenderCodeRemoveModalState = (): [VoidFunction, VoidFunction, boolean] => {
   const [{ setTrue, setFalse }, opened] = useBoolean();
   return [setTrue, setFalse, opened];
};

type EzwmSenderCodeRemoveProps = {
   readonly onRemoveSuccess: VoidFunction;
};

export const EzwmSenderCodeRemove = (props: EzwmSenderCodeRemoveProps): JSX.Element => {
   const [openModal, closeModal, modalOpened] = useEzwmSenderCodeRemoveModalState();
   const onRemoveSuccess = useCallback(() => {
      props.onRemoveSuccess();
      closeModal();
      // eslint-disable-next-line react-hooks/exhaustive-deps
   }, [closeModal, props.onRemoveSuccess]);
   return (
      <>
         <EzwmSenderCodeRemoveModalOpener onClick={openModal} />
         {modalOpened ? <EzwmSenderCodeRemoveModal onClose={closeModal} onRemoveSuccess={onRemoveSuccess} /> : null}
      </>
   );
};
